export const environment = {
  production: false,

  serverUrl: 'http://41.207.248.244:8181/api',

  envUrl: 'http://41.207.248.244:2800',
};
